import { confirmDeleteVersion } from '../../popup';

export const BinButton = ({ selectedVersion, viewportMode, onEditMode, dispatch, setOnEditMode }) => {
    const isVersionDeletable = selectedVersion >= 0;
    const isNotComparativeMode = viewportMode !== 'comparative';
    const shouldShowBin = isVersionDeletable && isNotComparativeMode && !onEditMode;

    if (!shouldShowBin) return null;

    return (
        <button className="icon-button delete-version-btn" onClick={() => confirmDeleteVersion(dispatch, setOnEditMode)} aria-label="Delete version">
            <img src="trash.svg" alt="delete" />
        </button>
    );
};
